'use client';

import { useEffect } from 'react';

// Ping interval: every 4 minutes (240,000 ms)
// Supabase free tier pauses after ~1 week of inactivity on the DB side
// but this ensures the app server and DB stay warm during active sessions
const PING_INTERVAL_MS = 4 * 60 * 1000;

export function useKeepAlive() {
  useEffect(() => {
    const ping = async () => {
      try {
        await fetch('/api/keep-alive', {
          method: 'GET',
          cache: 'no-store',
        });
      } catch {
        // Silently ignore — keep-alive is best-effort
      }
    };

    // Ping immediately on mount
    ping();

    // Then ping every 4 minutes
    const interval = setInterval(ping, PING_INTERVAL_MS);

    return () => clearInterval(interval);
  }, []);
}
